<template>
  <b-modal
    v-model="isVisible"
    title="Договор оферты"
    size="lg"
    scrollable
    :hide-footer="false"
    :hide-header-close="false"
    @ok="handleAccept"
    @cancel="handleCancel"
    ok-title="Принять условия"
    cancel-title="Отклонить"
    ok-variant="success"
    cancel-variant="secondary"
  >
    <div class="offer-content">
      <AgentsOferta />
    </div>
    
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <b-button variant="secondary" @click="handleCancel">
          Отклонить
        </b-button>
        <b-button variant="success" @click="handleAccept" :disabled="loading">
          <span v-if="loading">
            <i class="fas fa-spinner fa-spin mr-2"></i>Обработка...
          </span>
          <span v-else>
            Принять условия оферты
          </span>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { API_AGENT_COMPANY } from "@/constants";
import AgentsOferta from './AgentsOferta.vue'

export default {
  name: 'OfferAgreementModal',
  components: {
    AgentsOferta
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    agentCompanyId: {
      type: [Number, String],
      required: true
    },
    commissionRates: {
      type: Object,
      default: () => ({
        first_order: 30,
        first_year: 25,
        next_orders: 20
      })
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    async handleAccept() {
      this.loading = true;
      
      try {
        // Отправляем запрос на смену статуса на approved
        await api.call('post', `${API_AGENT_COMPANY}/${this.agentCompanyId}/change-status`, {
          new_status: 'approved',
          comment: 'Пользователь принял условия оферты'
        });
        
        // Уведомляем родительский компонент об успешном принятии
        this.$emit('offer-accepted');
        
        // Закрываем модальное окно
        this.isVisible = false;
        
        // Показываем уведомление об успехе
        this.$bvToast.toast('Оферта успешно принята! Теперь вы можете работать с системой.', {
          variant: 'success',
          title: 'Отлично!',
          autoHideDelay: 5000
        });
        
      } catch (error) {
        console.error('Ошибка при принятии оферты:', error);
        
        this.$bvToast.toast('Произошла ошибка при принятии оферты. Попробуйте еще раз.', {
          variant: 'danger',
          title: 'Ошибка'
        });
      } finally {
        this.loading = false;
      }
    },
    
    handleCancel() {
      this.isVisible = false;
      this.$emit('offer-cancelled');
    }
  }
};
</script>

<style scoped>
.offer-content {
  max-height: 600px;
  padding-right: 15px;
  overflow-y: auto;
}
</style>
